import { IGestaoDeVisitasBody, IGestaoDeVisitasResponse } from "../../../Interfaces/Vendas/GestaoDeVisitas/GestaoVisitasInterfaces";
import { GestaoDeVisitaServices, ListarPontosDeVendaServices } from "../../../Services/Vendas/GestaoDeVisitas/GestaoDeVisitaServices";
import { Controller } from "../../Controller";

export async function GestaoDeVisitaVendasController(
    pagina: number,
    responseBody: IGestaoDeVisitasBody,
) 
    {
        return (
            Controller(
                GestaoDeVisitaServices<IGestaoDeVisitasResponse>(pagina, responseBody, 0)

            )
        )
    }
export async function ExportarGestaoDeVisitaVendasController(
    requestBody: IGestaoDeVisitasBody,
    // pagina: number
)
    {
        return Controller(
            GestaoDeVisitaServices<Blob>(0, requestBody, 1)
        );
    }

    export async function ListarPontosDeVendaController(){
    return Controller(ListarPontosDeVendaServices());
}